// --------------------------------------------------------------
// Created On: 2026-07-12
// Author: Dimitra Weinstein
//
// Last Modified: 2026-07-14
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";

// UserInputField component for capturing and sending user messages in the AI agent chat window.
export default function UserInputField(props: Props): Component {
  return (
    <div className="small input-group">
      <textarea
        className="form-control form-control-sm"
        placeholder="Type your message..."
        aria-label="Type your message..."
        aria-describedby="send-user-message-button"
        data-test="user-message-input"
        rows={2}
        style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}
        value={props.userMessage}
        onChange={(e) => props.onHandleUserInput(e.target.value)}
        onKeyDown={async (e) => await props.onHandleKeyDown(e)}
      />
      <button
        className="btn btn-primary"
        type="submit"
        id="send-user-message-button"
        data-test="send-user-message-button"
        title="Send Message"
        onClick={async () => {
          await props.onHandleSendUserMessage();
        }}
        onKeyDown={async (e) => {
          if (!props.loading && e.key === "Enter") {
            e.preventDefault();
            await props.onHandleSendUserMessage();
          }
        }}
        disabled={props.userMessage.trim() === "" || props.loading}
      >
        Send
      </button>
    </div>
  );
}

interface Props {
  loading: boolean;
  userMessage: string;
  onHandleUserInput: (message: string) => void;
  onHandleKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => Promise<void>;
  onHandleSendUserMessage: () => Promise<void>;
}
